import { render, staticRenderFns } from "./Unicon.vue?vue&type=template&id=a88a03b4&"
import script from "./Unicon.vue?vue&type=script&lang=js&"
export * from "./Unicon.vue?vue&type=script&lang=js&"
import style0 from "./Unicon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports